import type { JSX } from 'react';
import { AppWindow } from '../window/AppWindow';
import { t } from '../messages';
import { ActivityBoard } from './ActivityBoard';
import './activity.css';

/**
 * La consigne **dans une fenêtre**, ouverte par l'icône du dock.
 *
 * Sans elle, la consigne serait invisible dès que l'élève ouvre son outil pour travailler — et
 * avec elle disparaîtraient le bouton « Vérifier mon travail » et le bouton « J'ai terminé »,
 * c'est-à-dire tout ce qu'on lui demande de faire à la fin. C'est donc la même carte, dans le même
 * chrome que « Mon compte » et l'espace enseignant : une page **du cœur**, dans une fenêtre du
 * cœur, sans rien de spécial accordé.
 *
 * Elle ne redessine rien : `ActivityBoard` est le même composant que celui posé sur le bureau nu.
 */
export function ActivityPage(): JSX.Element {
  return (
    <AppWindow title={t('activity.title')}>
      <div className="activity-page">
        <ActivityBoard />
      </div>
    </AppWindow>
  );
}
